<template>
  <div class="row"
    role="presentation">
    <div class="col-12"
      role="presentation">
      <h2>
        Ecosystem @ {{ blob.date }}
      </h2>
    </div>

    <div class="col-6"
      role="presentation">
      <h3>Bandwidth</h3>
      <table class="table">
        <tr>
          <th>Daily Peak Bandwidth</th>
          <td class="text-right">
            {{ traffic.ports.peak }}
          </td>
        </tr>
        <tr>
          <th>Daily Average Bandwidth</th>
          <td class="text-right">
            {{ traffic.ports.average }}
          </td>
        </tr>
      </table>

      <h3>Health</h3>
      <table class="table">
        <tr>
          <th>Active Locations</th>
          <td class="text-right">
            <a href="/ecosystem/locations">{{ locations.length }}</a>
          </td>
        </tr>
        <tr>
          <th>Active Customers</th>
          <td class="text-right">
            <a href="/ecosystem/active-customers">{{ blob.active_customers }}</a>
          </td>
        </tr>
        <tr />
        <tr>
          <th>Unique ASNs</th>
          <td class="text-right">
            {{ ecosystem.asns }}
          </td>
        </tr>
      </table>

      <el-tooltip class="item"
        effect="dark"
        content="Services either cancelled or terminated in the last 30 days">
        <h3 class="d-inline-block">
          Churn
        </h3>
      </el-tooltip>

      <table class="table">
        <tr>
          <th>MEGAPORT</th>
          <td class="text-right">
            {{ ecosystem.churn.MEGAPORT }}
          </td>
        </tr>
        <tr>
          <th>IX</th>
          <td class="text-right">
            {{ ecosystem.churn.IX }}
          </td>
        </tr>
        <tr>
          <th>VXC</th>
          <td class="text-right">
            {{ ecosystem.churn.VXC }}
          </td>
        </tr>
      </table>
    </div>

    <div class="col-6"
      role="presentation">
      <h3>Ports of Value</h3>
      <table class="table">
        <thead>
          <tr>
            <th />
            <el-tooltip class="item"
              effect="dark"
              content="Viable ports have two or more circuits, or 400 Mbps daily average or 200 Mbps monthly average"
              placement="bottom-end">
              <th>Viable Ports</th>
            </el-tooltip>

            <el-tooltip class="item"
              effect="dark"
              content="Underused ports have traffic but not a substantial amount, and they have less than two circuits attached"
              placement="bottom-end">
              <th>Underused Ports</th>
            </el-tooltip>

            <el-tooltip class="item"
              effect="dark"
              content="Unused ports either have no circuits or very little traffic (< 5Mbps). These are at risk"
              placement="bottom-end">
              <th>Unused Ports</th>
            </el-tooltip>
          </tr>
        </thead>
        <tbody>
          <tr v-for="country in ports_by_class"
            :key="country.country">
            <td>{{ country.country }}</td>
            <td>{{ country.viable }}</td>
            <td>{{ country.underused }}</td>
            <td>{{ country.unused }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as Forge from '@/plugins/forge'

export default {
  name: 'DashPulse',

  props: {
    locations: {
      type: Array,
      required: true,
    },
  },

  data: function () {
    return {
      blob: {},
      ecosystem: {
        churn: {
          MEGAPORT: 0,
          IX: 0,
          VXC: 0,
        },
      },
      ports_by_class: [],
      traffic: {
        ports: {
          peak: null,
          average: null,
        },
      },
    }
  },

  created: function () {
    this.getTableData()
  },

  methods: {
    getTableData: function () {
      const countries = this.locations
        .map(loc => loc.country)
        .uniq()
        .sort()

      Forge.get('/v1/usage/daily-pulse', {
        success: res => {
          const blob = res.data.json
          blob.date = res.data.ts_date

          this.blob = blob

          Object.keys(blob.traffic).forEach(k => {
            Object.keys(blob.traffic[k]).forEach(l => {
              if (typeof this.traffic[k] === 'undefined') this.traffic[k] = {}

              if (typeof blob.traffic[k] !== 'undefined') this.traffic[k][l] = Forge.bandwidthUnits(blob.traffic[k][l])
            })
          })

          this.ports_by_class = countries.map(c => {
            return {
              country: c,
              viable: blob.lists.viable[c] ? blob.lists.viable[c].length : 0,
              underused: blob.lists.underused[c] ? blob.lists.underused[c].length : 0,
              unused: blob.lists.unused[c] ? blob.lists.unused[c].length : 0,
            }
          })
        },
      })

      Forge.get('/v1/mega/ecosystem', {
        success: res => {
          this.ecosystem = res.data
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 1rem;
}
</style>
